var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_2514)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0602 1H2.93983C1.86849 1 1 1.86849 1 2.93983V21.0602C1 22.1315 1.86849 23 2.93983 23H21.0602C22.1315 23 23 22.1315 23 21.0602V2.93983C23 1.86849 22.1315 1 21.0602 1Z",
    fill: "#F1F2F2",
    stroke: "#FAD336",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41182 17.1462C4.41182 18.4822 5.49233 19.5653 6.82521 19.5653C8.15808 19.5653 9.23859 18.4822 9.23859 17.1462L9.23859 6.85369C9.23859 5.51766 8.15808 4.4346 6.82521 4.4346C5.49233 4.4346 4.41182 5.51766 4.41182 6.85369L4.41182 17.1462Z",
    fill: "#FF5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88213 15.6884L14.6855 5.88502C14.9357 5.63489 15.331 5.64296 15.5731 5.88502L18.0905 8.40244C18.3406 8.65257 18.3326 9.04793 18.0905 9.28999L8.2871 19.0934C8.03697 19.3435 7.64161 19.3355 7.39955 19.0934L4.88213 16.576C4.632 16.3258 4.64007 15.9305 4.88213 15.6884Z",
    fill: "#FFA819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85375 14.7271C5.51772 14.7271 4.43466 15.8076 4.43466 17.1405C4.43466 18.4734 5.51772 19.5539 6.85375 19.5539H17.1463C18.4823 19.5539 19.5654 18.4734 19.5654 17.1405C19.5654 15.8076 18.4823 14.7271 17.1463 14.7271H6.85375Z",
    fill: "#2820FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83092 17.8423C7.20904 17.8423 7.51557 17.5358 7.51557 17.1577C7.51557 16.7795 7.20904 16.473 6.83092 16.473C6.4528 16.473 6.14627 16.7795 6.14627 17.1577C6.14627 17.5358 6.4528 17.8423 6.83092 17.8423Z",
    fill: "#F75500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_2514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.543fe9c547a44530ae98fb4b3ab7efed.svg";
export { ForwardRef as ReactComponent };